// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root___apV2","rootCenter":"LoadMoreObserver_rootCenter__1idL4","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__16yAl"};